import { useContext } from "react";
import { AuthContext } from "@/auth/AuthProvider";

/**
 * Hook to access authentication context.
 * Must be used within an AuthProvider.
 *
 * @returns AuthContextValue with user, loading state, and auth actions
 * @throws Error if used outside of AuthProvider
 */
export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
}
